import actions from "./actions";

const initState = {
  idToken: null,
  roleId: null,
  clientId: null,
  expireTime: null,
  permissionItems: null,
  userSetting: null,
  roleIndex: null,
};

function parseMaybeArray(value) {
  if (Array.isArray(value)) return value; // already an array
  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : "";
    } catch {
      return "";
    }
  }
  return "";
}

export default function authReducer(state = initState, action) {
  switch (action.type) {
    case actions.LOGIN_SUCCESS:
      // todo
      // save ACL

      return {
        ...state,
        idToken: action.token,
        roleId: action?.role,
        clientId: action?.clientId || action?.objectId,
        expireTime: action?.expireTime,
        permissionItems: action?.permissionItems,
        userSetting: action?.userSetting,
        roleIndex: action?.roleIndex,
        username: action?.username,
        name: action?.name,
        sessionToken: action?.sessionToken,
        status: action?.status,
        objectId: action?.objectId,
        merchants: parseMaybeArray(action?.merchants)
      };

    case actions.LOGOUT:
      return initState;
    default:
      return state;
  }
}
